import { render, staticRenderFns } from "./StudentUpdateForm.vue?vue&type=template&id=71d706ae"
import script from "./StudentUpdateForm.vue?vue&type=script&lang=js"
export * from "./StudentUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports